import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, TextStyle } from "pixi.js";
import { UnboardingResourcePackage } from "../../resources/UnboardingResourcePackage";
import { EarnCoinsContainer } from "./textcontainers/EarnCoinsContainer";
import { UpgradeBuildingContainer } from "./textcontainers/UpgradeBuildingContainer";
import { EarnPointsContainer } from "./textcontainers/EarnPointsContainer";
import { PiggyBankContainer } from "./textcontainers/PiggyBankContainer";

export class UnboardingSecondPageTextContainer extends Container {

    public constructor(unboardingResources: UnboardingResourcePackage) {
        super();
        const earnCoinsContainer = new EarnCoinsContainer(unboardingResources);
        this.addChild(earnCoinsContainer);
        const upgradeContainer = new UpgradeBuildingContainer(unboardingResources);
        upgradeContainer.position.set(-312, 128);
        this.addChild(upgradeContainer);
        const earnPointsContainer = new EarnPointsContainer(unboardingResources);
        earnPointsContainer.position.set(51, 310);
        this.addChild(earnPointsContainer);
        const piggyContainer = new PiggyBankContainer(unboardingResources);
        piggyContainer.position.set(-335, 400);
        this.addChild(piggyContainer);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 78,
            fill: 'ffffff'
        });
    }
}